<template>
  <div class="description" v-html="description"></div>
</template>

<script>
export default {
  props: ['description']
}
</script>

<style lang="scss" scoped>
.description {
  //  background: #f4f4f4;
  //flex-grow: 1;
  border-radius: 10px;
  margin: 0;
  padding: 5px 20px 10px;
  overflow: auto;
  //  font-style: italic;

  :deep(h1),
  :deep(h2) {
    font-weight: 600;
    color: #4f4f4f;
    margin-bottom: 3px;
  }
}
</style>
